<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="420">   
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          請聯繫管理人員
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:110px; font-size:15px">
          <span class="start">考試前</span>：如需修改報名資訊，煩請寄信至 service@cerps.org.tw並註明場次代碼、姓名、欲修改內容。
          <span class="start">考試後</span>：如需修改資訊，煩請進行申請補換發程序。謝謝您 !
        </v-card-text>
        <v-row justify="center">          
          <v-card-actions>          
            <v-btn outlined color="#FFF" style="width:150px; height:46px; border-radius:10px; background:#81C0E2"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'AdjustmentRegister',
    data () {
      return {
        active: false,
      }
    },
    methods:{
      open(data){
        this.active = true
        this.sendType = data
      },
      close(){
        this.active = false
      },
      save(){
        this.close()
      }
    }
  }
</script>